import * as Yup from 'yup';

export const forReviewInitialValues = {
    description: '',
    startDate: null,
    endDate: null,
    amount: '',
    dateBuffer: '5',
    amountBuffer: '0.02',
    hasMatches: { value: 'all', label: 'All' },
    bankAccount: 'all',
    type: { value: 'all', label: 'All' },
};

export const forReviewSchema = Yup.object({
    endDate: Yup.date().nullable(),
    amount: Yup.number().nullable(),
    startDate: Yup.date().nullable(),
    description: Yup.string().nullable(),
    dateBuffer: Yup.string().required(),
    amountBuffer: Yup.string().required(),
    hasMatches: Yup.object()
        .shape({
            value: Yup.string().required('Matches value is required'),
            label: Yup.string().required('Matches label is required'),
        })
        .nullable(),
    bankAccount: Yup.string().nullable(),
    type: Yup.object()
        .shape({
            value: Yup.string().required('Type value is required'),
            label: Yup.string().required('Type label is required'),
        })
        .nullable(),
});
